











































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import moment from 'moment';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import {
  fetchVehiculosDetalle,
  fetchTarifas,
  getTipoVehiculos,
  MsResponseData,
} from '@/pantallas/Peajes/Asignacion/fetchData';
import VerDetalleModal from '@/pantallas/Peajes/Asignacion/VerDetalleModal.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    VerDetalleModal,
  },
})
export default class AsignacionPantalla extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.AsignarVehiculosPeajes;
  loadingService = new LoadingService();

  requestsStart: number = 0;
  MsResponseData: MsResponseData = null;
  detalleSeleccionado: any = null;
  peajeSeleccionado: number = 0;
  mostrarModalVerDetalle: boolean = false;
  infoItems: any[] = [];
  infoTypeReport: string = '';
  showInfoDialog: boolean = false;
  verDetalle: boolean = false;
  buscarVehiculo: string = '';

  gridApi: GridApi = null;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'ID',
        field: 'cod_vehiculo',
        hide: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente',
        field: 'patente_vehiculo',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Flota',
        field: '__nom_flota',
        cellStyle: { textAlign: 'left' },
        width: 320,
      },
      {
        headerName: 'Tipo Vehículo',
        field: '__desc_tipo_vehiculo',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Activo',
        field: 'peajes',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'avl',
        cellStyle: { textAlign: 'left' },
      },
      // {
      //   headerName: 'Aplicaciones',
      //   field: 'aplicaciones',
      //   cellStyle: { textAlign: 'left' },
      //   type: 'medalColumn',
      //   tooltipField: 'country',
      //   cellRenderer: () => {
      //     return '<i class="material-icons" id="5545" title="Ver Filtros" style="width: 28px; height: 28px; margin-top: 10%" >info_outlined</i>';
      //   },
      //   onCellClicked: this.handleClickInfo,
      //   columnGroupShow: 'closed',
      // },
    ].map(x => ({
      width: 250,
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.buscarVehiculos();
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  accionesTotales: PermisoAccion[] = [];

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  fetchVehiculosDetalle(flotas: any) {
    this.showLoading();
    return fetchVehiculosDetalle(flotas)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  async buscarVehiculos() {
    this.MsResponseData = (await this.fetchVehiculosDetalle([])) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.gridApi.setRowData(this.MsResponseData.data);
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  handleClickInfo(event: any) {
    var itemsInfo: any[] = [];
    if (event.value != '' && event.value != undefined && event.value != null) {
      for (var key in event.value) {
        if (event.value.hasOwnProperty(key)) {
          itemsInfo.push({ key: key, value: event.value[key].appname });
        }
      }
    }
    if (itemsInfo.length == 0) {
      itemsInfo.push({ key: 1, value: 'Sin Aplicaciones' });
    }
    this.infoItems = itemsInfo;
    this.infoTypeReport = event.data.nombre_reporte;
    this.showInfoDialog = true;
  }

  onFilterPeajes() {
    if (this.buscarVehiculo.length > 1) {
      this.gridApi.setQuickFilter(this.buscarVehiculo);
    } else {
      this.gridApi.setQuickFilter('');
    }
  }

  preventEnter(event: any) {
    if (event.key == 'Enter') {
      event.preventDefault();
    }
  }

  filtroForm(filtros: any) {
    this.buscarVehiculos();
  }
  handleVerDetalleClick(params: ICellRendererParams) {
    this.verDetalle = true;
    this.detalleSeleccionado = params.data;
    // this.peajeSeleccionado = this.detalleSeleccionado.cod_vehiculo;
    this.buscarTarifas(this.detalleSeleccionado.cod_vehiculo);
  }

  handleEditarClick(params: ICellRendererParams) {
    this.verDetalle = false;
    this.detalleSeleccionado = params.data;
    console.log(this.detalleSeleccionado);
    // this.peajeSeleccionado = this.detalleSeleccionado.cod_vehiculo;
    this.buscarTarifas(this.detalleSeleccionado.cod_vehiculo);
  }

  async buscarTarifas(id: number) {
    this.MsResponseData = (await this.fetchTarifas(id)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.detalleSeleccionado = this.MsResponseData.data[0];
          this.mostrarModalVerDetalle = true;
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  fetchTarifas(id_peaje: number) {
    this.showLoading();
    return fetchTarifas(id_peaje)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
    this.buscarVehiculos();
  }
  clearForm() {
    this.buscarVehiculos();
  }
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    //@ts-ignore
    if (this.gridApi.rowModel.rowsToDisplay.length == 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  }
}
